import { DomUtils } from "./utils";
import { mobileNavInit } from './MobileNav';
import { playerItemListFiltersInit } from "./PlayerItemListFilters";
import { initGlobalPageHeader } from "./GlobalPageHeader";
// import {playerTooltipInit} from "./PlayerTooltips";
import { chemStyleSelectorsInit } from "./ChemStyleSelectors";
import { futLibraryInit } from "./FutLibrary";
import { globalMegaMenuInit } from './GlobalMegaMenu';
import { cardViewSwitcherInit } from './CardViewSwitcher';
import { homepageScrollerInit } from './HomepageScroller';
import { swapsCombinationsInit } from './SwapsCombinations';
import { ggaInit } from "./GGA";
import { tabsInit } from './Tabs';
import { modalInit } from "./Modal";
import { KMMPlayerPickerInit } from "./KMMPlayerPicker";
DomUtils.onDomContentLoaded(function () {
    mobileNavInit();
    playerItemListFiltersInit();
    // playerTooltipInit(document);
    initGlobalPageHeader();
    globalMegaMenuInit();
    chemStyleSelectorsInit();
    homepageScrollerInit();
    futLibraryInit();
    cardViewSwitcherInit();
    swapsCombinationsInit();
    ggaInit();
    tabsInit();
    modalInit();
    KMMPlayerPickerInit();
});
